<div class="container-fluid">
  <div class="header-container">
    <div class="row justify-content-start mb-2">
      <div class="col-12">
      <span class="iso-header ml-2">
  {{ (showFittings ? "bikeshop.shop_setup.card_headers.fittings" : "bikeshop.menu.service_types") | translate }}
</span>
      </div>
      <!--        <div class="col-3 justify-content-end d-flex">-->
      <!--          <daz-icon class="iso-search-icon" [name]="'search'" [size]="'22px'"-->
      <!--                    [color]="'#888888'"></daz-icon>-->
      <!--          <input (keyup)="searchSettings()" [(ngModel)]="userSearchTerm" class="iso-search-bar" type="text"-->
      <!--                 placeholder="Search">-->
      <!--          &lt;!&ndash;        &ndash;&gt;-->

      <!--        </div>-->
    </div>
    <div style="margin-left: auto;">
      <button *ngIf="!showFittings" style="margin-right: 10px;height: 48px; width: 200px" type="button"
              class="iso-round-button-icon" id="btnServiceImportData"
              [routerLink]="['/store/service-types-import']">

        <daz-icon class="iso-button-icon" [name]="'upload'" [size]="'22px'"
                  [color]="'#ffffff'"></daz-icon>
        {{ 'bikeshop.service_types.import_data' | translate }}</button>
      <button style="width: 180px;height: 48px;" type="button" class="iso-round-button-icon"
              (click)="toggleAdd()" id="btnAddNewServiceType">
        <daz-icon class="iso-button-icon" style="margin-top: 3px" [name]="'plus'" [size]="'22px'"
                  [color]="'#ffffff'"></daz-icon>
        {{ 'bikeshop.service_types.add_new' | translate }}
      </button>
      <div class="option-box" [ngClass]="{ hide: !addNew }">
        <div class="option" (click)="addServiceType()">
          {{  (showFittings ? 'bikeshop.service_types.new_fitting' : 'bikeshop.service_types.new_service') | translate }}
        </div>
        <div class="option" (click)="addCategory()">
          {{ 'bikeshop.service_types.new_category' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div>

    <div class="filter-container content">
      <div class="legend-container">
        <div class="" *ngIf="isPortal">
          <daz-icon class="iso-search-icon-service" [name]="'search'" [size]="'22px'"
                    [color]="'#888888'"></daz-icon>
          <input class="iso-search-bar-service" type="text" placeholder="{{ 'general.search' | translate }}"
                 (input)="setSearch($event.target['value'] )"/>
        </div>
        <div>
          <div class="technicians ml-2">
            <i *ngFor="let technician of technicians">
              <avatar size=25 name="{{technician.Firstname+' '+technician.Surname}}"
                      profilePhoto=""></avatar>
            </i>
          </div>
          <span class="legend"
                style="margin-left:8px;">{{ 'bikeshop.service_types.technician_linked' | translate }}</span>
        </div>
        <!--        <div><i class="fa hubtiger-calendar" aria-hidden="true"></i><span-->
        <!--          class="legend">{{ 'bikeshop.service_types.external_booking' | translate }}</span></div>-->
        <!--        <div *ngIf="showFittings == true"><i class="fa hubtiger-measuring-tape" aria-hidden="true"></i><span-->
        <!--          class="legend">{{ 'bikeshop.service_types.bike_fitting' | translate }}</span></div>-->
        <!--        <div><i class="fa fa-barcode" aria-hidden="true"></i><span-->
        <!--          class="legend">{{ 'bikeshop.service_types.sku_linked' | translate }}</span></div>-->
      </div>


    </div>

    <div class="iso-content margin-top-16">
      <app-shared-service *ngIf="!loading" [currencySymbol]="partner.CurrencySymbol" [Categories]="Categories"
                          [isPortal]="isPortal" [categoryView]="categoryView" [searchService]="search"
                          [setCategories]="setCategories"
                          [technicians]="technicians">
      </app-shared-service>
    </div>
  </div>
</div>
